function Footer() {
  return (
    <>
    <footer className="footer">
      <p>© Debug-Dynamos. All the best debugers.</p>
    </footer>
    </>
  );
}

export default Footer;
